/** @jsxImportSource @emotion/react */
import React from 'react'
import { DrawerForm, DrawerPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/DrawerContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, manageDrawer } = breadcrumbItems

const ManageNews: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, manageDrawer]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <DrawerForm />
        </div>
        <div css={styles.right}>
          <DrawerPreview />
        </div>
      </div>
    </Provider>
  )
}

export default ManageNews
